import * as lottieAnimation from "./lottie_shopping_bag.json";
import Lottie from "react-lottie";

export default function Connection(props) {
  const { height = 400, width = 400 } = props;

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: lottieAnimation.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Lottie
      options={lottieOptions}
      height={height}
      width={width}
      style={{ cursor: "auto" }}
      isClickToPauseDisabled={true}
    />
  );
}
